import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { IBusyConfig, BUSY_CONFIG_DEFAULTS } from 'tixif-ngx-busy';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'mc-indicator',
  templateUrl: './indicator.component.html',
  styleUrls: ['./indicator.component.scss']
})
export class IndicatorComponent implements OnInit {

  @Input() set busy(value: Promise<any> | Subscription | Array<Promise<any> | Subscription>) {
    this.busyConfig.busy = value;
  }

  @Input() set message(value: string) {
    this.busyConfig.message = value || this.busyConfig.message;
  }

  public get busyCfg(): IBusyConfig {
      return this.busyConfig;
  }

  protected busyConfig: IBusyConfig = Object.assign({}, BUSY_CONFIG_DEFAULTS);

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/ui/indicator/indicator.component.ts